// removed by extract-text-webpack-plugin
module.exports = {"Banner":"src-pages-styles----home-module---Banner---1yR8w","Subtitle":"src-pages-styles----home-module---Subtitle---1VepU","VerticalLine":"src-pages-styles----home-module---VerticalLine---3WWLi","HorizontalLine":"src-pages-styles----home-module---HorizontalLine---2TzBh","Project":"src-pages-styles----home-module---Project---3MX6K","ProjectDescription":"src-pages-styles----home-module---ProjectDescription---1QpVP","ProjectImage":"src-pages-styles----home-module---ProjectImage---KYmV1","Match":"src-pages-styles----home-module---Match---1m7Ha"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/styles/home.module.css
// module id = 296
// module chunks = 35783957827783